export default {
      id: "icon-nav-down-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-nav-down",
      toString: function () {
        return this.url;
      }
    }